"use client";
import {
  switch_default
} from "./chunk-J6JGI6RM.mjs";
import {
  useSwitch
} from "./chunk-EN4B57RQ.mjs";
export {
  switch_default as Switch,
  useSwitch
};
